<script setup lang="ts">
import { inject, PropType, reactive, ref } from 'vue'
import { push } from '@/utils'
// types
import { ItemInfo, ugcType } from '@/components/GlobalUgcPopup/types'

const props = defineProps({
  item: {
    type: Object as PropType<ItemInfo>,
    default: () => {},
  },
  showLine: {
    type: Boolean,
    default: false,
  },
  user: {
    type: Object,
    default: () => {},
  },
})
const isShowUgcPopup = inject('isShowUgcPopup', ref(false))
const isShowConfirmPopup = inject('isShowConfirmPopup', ref(false))
const globalUgcTechDislikeInfo = inject<any>('globalUgcTechDislikeInfo', reactive({}))

// 点击
const itemClick = async () => {
  globalUgcTechDislikeInfo.id = props.user.userId
  if (props.item.type === ugcType.DISLIKETA) {
    // 不喜欢ta
    globalUgcTechDislikeInfo.type = 0
    isShowUgcPopup.value = false
    isShowConfirmPopup.value = true
  } else if (props.item.type === ugcType.NOTVIEWTA) {
    // 不看ta
    globalUgcTechDislikeInfo.type = 1
    isShowUgcPopup.value = false
    isShowConfirmPopup.value = true
  } else if (props.item.type === ugcType.REPORTTA) {
    // 举报ta
    isShowUgcPopup.value = false
    isShowConfirmPopup.value = false
    push('/myModule/contentReport/index', {
      mediaId: props.user?.mediaId || props.user?.media,
    })
  } else if (props.item.type === ugcType.REPORTCOMMENT) {
    // 举报评论
    isShowUgcPopup.value = false
    isShowConfirmPopup.value = false
    push('/evaluationModule/report/index', {
      showId: props.user?.showId,
      commentId: props.user?.commentId,
      type: 1,
      fromUgc: 1,
    })
  } else {
    isShowUgcPopup.value = false
    isShowConfirmPopup.value = false
  }
}
</script>

<template>
  <div class="item-panel flex_between" :class="{ bdb: showLine, center: item?.layout === 'center' }" @click.stop="itemClick">
    <div class="item-con flex_align_center">
      <i class="wy-iconfont fs-24" :class="[item.icon]"></i>
      <div class="panel-con margin-l12" :class="{ lh24: !item?.tips }">
        <div class="title fs-14">{{ item.title }}</div>
        <div class="tips fs-12 margin-t6" v-if="item?.tips">{{ item.tips }}</div>
      </div>
    </div>
    <i class="wy-iconfont icon-xianxing-jiantou-you fs-12 bold" v-if="item.arrow"></i>
  </div>
</template>

<style scoped lang="scss">
.item-panel {
  padding: 12px 0;
  position: relative;
  align-items: center;

  &.bdb {
    &::after {
      content: '';
      width: 278px;
      height: 1px;
      background-color: #f9f9f9;
      position: absolute;
      left: 3px;
      bottom: 0;
    }
  }

  .wy-iconfont {
    color: #1a1a1a;
  }

  .item-con {
    width: 255px;
    align-items: center;

    .panel-con {
      line-height: 16px;

      &.lh24 {
        line-height: 24px;
      }

      .title {
        color: #1a1a1a;
        font-weight: 500;
      }

      .tips {
        color: #7c889c;
      }
    }
  }

  &.center {
    align-items: center;
    justify-content: center;

    .item-con {
      width: auto;

      .panel-con {
        margin-left: 3px;
      }
    }
  }
}
</style>
